import React from 'react';
import { AlertTriangle, Clock, CreditCard } from 'lucide-react';

const SubscriptionWarning = ({ user, onRenewClick }) => {
  if (!user?.subscriptionExpired) return null;

  const daysRemaining = user.daysRemaining || 0;
  const isAdminDeactivated = user.adminDeactivated;
  const isUrgent = daysRemaining <= 2 && !isAdminDeactivated;

  // Different styling for admin deactivation vs subscription expiration
  const bgColor = isAdminDeactivated ? 'bg-red-50 border-red-400 text-red-800' : 
                  isUrgent ? 'bg-red-50 border-red-400 text-red-800' : 
                  'bg-yellow-50 border-yellow-400 text-yellow-800';

  const iconColor = isAdminDeactivated ? 'text-red-400' : 
                    isUrgent ? 'text-red-400' : 'text-yellow-400';

  const isUserDeactivated = user.userDeactivated;
  
  const title = isUserDeactivated ? 'User Account Deactivated by Administrator' :
                isAdminDeactivated ? 'Team Deactivated by Administrator' :
                isUrgent ? 'Urgent: Subscription Expired' : 
                'Subscription Expired - Limited Access';

  const message = isUserDeactivated ? 
    'Your user account has been deactivated by an administrator. Only account management is available.' :
    isAdminDeactivated ? 
    'Your team has been deactivated by an administrator. Only account management is available.' :
    `Your subscription has expired. You have ${daysRemaining} day${daysRemaining !== 1 ? 's' : ''} remaining to renew before your account is fully suspended.`;

  const buttonText = isAdminDeactivated ? 'Contact Support' : 'Renew Subscription Now';
  const buttonColor = isAdminDeactivated ? 'bg-red-600 hover:bg-red-700 focus:ring-red-500' :
                      isUrgent ? 'bg-red-600 hover:bg-red-700 focus:ring-red-500' : 
                      'bg-yellow-600 hover:bg-yellow-700 focus:ring-yellow-500';

  return (
    <div className={`border-l-4 p-4 mb-6 ${bgColor}`}>
      <div className="flex items-start">
        <div className="flex-shrink-0">
          {isAdminDeactivated ? (
            <AlertTriangle className={`h-5 w-5 ${iconColor}`} />
          ) : isUrgent ? (
            <AlertTriangle className={`h-5 w-5 ${iconColor}`} />
          ) : (
            <Clock className={`h-5 w-5 ${iconColor}`} />
          )}
        </div>
        <div className="ml-3 flex-1">
          <h3 className="text-sm font-medium">{title}</h3>
          <div className="mt-2 text-sm">
            <p>{message}</p>
            <p className="mt-1">
              <strong>Current access:</strong> Login and {isAdminDeactivated ? 'account' : 'billing'} management only. 
              Leave requests, approvals, and team management are disabled.
            </p>
          </div>
          <div className="mt-4">
            <button
              onClick={isAdminDeactivated ? () => window.location.href = 'mailto:support@leavewise.cloud' : onRenewClick}
              className={`inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white ${buttonColor} focus:outline-none focus:ring-2 focus:ring-offset-2`}
            >
              <CreditCard className="h-4 w-4 mr-2" />
              {buttonText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionWarning;
